/**
 * Internal function that loads <script> tags into head dynamically.
 *
 * @param {string} src - The source URL of the script to load.
 * @param {{ async?: boolean; type?: string }} [attributes] - Optional script attributes.
 * @param {boolean} [attributes.async] - Whether to load the script asynchronously.
 * @param {string} [attributes.type] - The MIME type of the script (e.g., "module").
 * @returns {Promise<void>} A promise that resolves when the script loads or rejects on error.
 */
export function loadScript(src, attributes) {
    if (!window.scriptLoaders) {
        window.scriptLoaders = {};
    }
    if (!window.scriptLoaders[src]) {
        const script = document.createElement('script');
        if (attributes === null || attributes === void 0 ? void 0 : attributes.async) {
            script.async = true;
        }
        if (attributes === null || attributes === void 0 ? void 0 : attributes.type) {
            script.type = attributes.type;
        }
        window.scriptLoaders[src] = new Promise((resolve, reject) => {
            script.onload = () => {
                resolve();
                script.remove();
            };
            script.onerror = (event, source, lineno, colno, error) => {
                console.error(`Failed to load script ${src}`, {
                    event,
                    source,
                    lineno,
                    colno,
                    error,
                });
                reject(new Error(`Failed to load script ${src}`));
                script.remove();
            };
        });
        // set src after events have registered;
        script.src = src;
        document.head.appendChild(script);
    }
    return window.scriptLoaders[src];
}
